var map = {
	"./about-us.svg": 1313,
	"./betting-icon.svg": 1314,
	"./bonus.svg": 1315,
	"./coin.png": 1316,
	"./contact-us.svg": 1317,
	"./download-app.svg": 1318,
	"./edit-btn.svg": 1319,
	"./feedback.svg": 1320,
	"./global.svg": 1321,
	"./info-centre.svg": 1322,
	"./mall-icon.svg": 1323,
	"./message.svg": 1324,
	"./redemption-icon.svg": 1325,
	"./referral.svg": 1326,
	"./resp-gaming.svg": 1327,
	"./security.svg": 1328,
	"./transaction-icon.svg": 1329,
	"./vip-icon.svg": 1330,
	"./wallet-icon.svg": 1331
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1312;